import minbackground from "../../assets/img/Backgrounds/Hintergrund_2.png";
import minres from "../../assets/img/responsive_backgrounds/new/Responsive_Hintergrund2.png";
import { useScreenWidth } from "../../ScreenWidthContext";
import { Container } from "react-bootstrap";

function LoadingTourPlannerSection() {
    const screenWidth = useScreenWidth();
    return(
        <Container fluid className="position-relative ps-0 pe-0" id="a-tourplanner" minbg={(screenWidth < 600) ? minres : minbackground}>
            <p style={{textAlign: "center"}}>Loading...</p>
        </Container>
    );
}

export default LoadingTourPlannerSection;